import { render } from "./ListShips.vue?vue&type=template&id=4407ec60&lang=pug"
import script from "./ListShips.vue?vue&type=script&lang=js"
export * from "./ListShips.vue?vue&type=script&lang=js"

import "./ListShips.vue?vue&type=style&index=0&id=4407ec60&lang=scss"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__